import { useRef, useEffect } from 'react';
function createRootElement(containerClass) {
  var rootContainer = document.createElement('div');
  rootContainer.setAttribute('class', containerClass);
  return rootContainer;
}
function addRootElement(rootElem, container) {
  var insertContainer = container || document.body;
  if (typeof insertContainer === 'string') {
    insertContainer = document.querySelectorAll(container).item(0);
  }
  insertContainer.insertBefore(rootElem, insertContainer.lastElementChild ? insertContainer.lastElementChild.nextElementSibling : null);
}
function usePortal(containerClass, container) {
  var rootElemRef = useRef(null);
  useEffect(function setupElement() {
    var existingParent = document.querySelectorAll(".".concat(containerClass)).item(0);
    var parentElem = existingParent || createRootElement(containerClass);
    if (!existingParent) {
      addRootElement(parentElem, container);
    }
    parentElem.appendChild(rootElemRef.current);
    return function removeElement() {
      rootElemRef.current.parentNode.removeChild(rootElemRef.current);
      if (parentElem.childNodes.length === 0) {
        parentElem.parentNode.removeChild(parentElem);
      }
    };
  }, []);
  function getRootElem() {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
    }
    return rootElemRef.current;
  }
  return getRootElem();
}
export default usePortal;